import { initializeBurgerMenu } from './js/burgerLogic';
import './css/style.scss';

document.addEventListener('DOMContentLoaded', () => {
  initializeBurgerMenu();

  const links = document.querySelectorAll('.navLink');
  const url = window.location.pathname;
  const homeId = document.getElementById('home');
  const logoAnhcor = document.getElementById('logoAnhcor');

  links.forEach(link => {
    if (link.getAttribute('href') === url) {
      setTimeout(() => {
        link.classList.add('active');
      }, 50);
    }
  });

  if (url === '/' || url === '/tr/' || url === '/es/') {
    homeId.classList.add('hidden');
    logoAnhcor.classList.add('pointer-events-none', 'cursor-not-allowed');
  } else {
    homeId.classList.remove('hidden');
    logoAnhcor.classList.remove('pointer-events-none', 'cursor-not-allowed');
  }
});

const form = document.getElementById('contact-form');
const notif = document.getElementById('notification');

form?.addEventListener('submit', event => {
  event.preventDefault();
  notif.classList.remove('hidden');

  setTimeout(() => {
    notif.classList.add('hidden');
    form.reset();
  }, 3000);
});

const lang = document.getElementById('langList');
const btnLang = document.getElementById('btnLang');

btnLang?.addEventListener('click', event => {
  lang.classList.toggle('hidden');
});

document.querySelectorAll('.accordion').forEach(button => {
  button.addEventListener('click', () => {
    const panel = button.nextElementSibling;

    // Toggle visibility
    panel?.classList.toggle('hidden');

    // Optional: Scroll into view
    if (!panel.classList.contains('hidden')) {
      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});
